var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.2966L4 22.667V18.9633M4 13.0374V9.33366L7 7.70403M13 4.29662L16 2.66699L19 4.29662M25 7.70403L28 9.33366V13.0374M28 18.9633V22.667L25 24.3263M19 27.704L16 29.3337L13 27.704M16 16.0003L19 14.3707M25 10.9633L28 9.33366M16 16.0003V19.704M16 25.63V29.3337M16 16.0003L13 14.3411M7 10.9633L4 9.33366",
    stroke: "#090909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F2F2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ar-label",
    d: "M16.2732 18L14.3052 12.664H12.2732L10.3052 18H12.0572L12.2652 17.312H14.3132L14.5212 18H16.2732ZM13.8972 15.968H12.6812L13.2892 14.088L13.8972 15.968ZM21.3369 18L20.3689 16.112C20.7929 15.904 21.3289 15.416 21.3289 14.496C21.3289 13.496 20.6569 12.664 19.4089 12.664H16.5609V18H18.1769V16.288H18.7609L19.4969 18H21.3369ZM19.6889 14.472C19.6889 14.768 19.4329 14.944 19.1609 14.944H18.1769V14.008H19.1609C19.4329 14.008 19.6889 14.184 19.6889 14.472Z",
    fill: "#090909"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.a5564b983533031c06130f1553a23cc6.svg";
export { ForwardRef as ReactComponent };